/**
 * Swiper configurations
 */

(function($, undefined) {

    // Hero slider Product list
    function heroSliderProductList() {
        var slides_shown = 4;

        // TODO: locate this slider and check if still relevant
        // if( $('.js-hero-slider-product-list-single').length ) {
        //     class_name = '.js-hero-slider-product-list-single';
        //     slides_shown    = 3;
        // }

        if (slides_shown) {
            const productSwiper = new window.Swiper('.slider-product .slider', {
                slidesPerView: 2,
                slidesPerGroup: 2,
                loop: true,
                autoplay: false,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.slider-button-next',
                    prevEl: '.slider-button-prev',
                },
                pagination: {
                    el: '.slider-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    768: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },

                },
            });
        }
    }

    heroSliderProductList();


    const pdpSwiper = new window.Swiper('.swiper-container.product-carousel-indicators-container', {
        direction: 'horizontal',
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: false,
        autoplay: false,
        spaceBetween: 8,
        breakpoints: {
            576: {
                slidesPerView: 6,
                slidesPerGroup: 6,
            },
            991: {
                slidesPerView: 4.95,
                slidesPerGroup: 4.95,
            },
        },
    });


    function shopProductSlider() {
        new window.Swiper('.shop-product-slider', {
            slidesPerView: 'auto',
            loop: false,
            autoplay: false,
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev',
            },
            pagination: false,
        });
    }

    shopProductSlider();

    new window.Swiper('.shop-categories-slider', {
        slidesPerView: 6,
        loop: false,
        autoplay: false,
        enabled: false,
        navigation: {
            nextEl: '.slider-button-next-categories',
            prevEl: '.slider-button-prev-categories',
        },
        pagination: false,
        breakpoints: {
            576: {
                slidesPerView: 3,
                enabled: true,
                spaceBetween: 24,
            },
            768: {
                slidesPerView: 4,
                enabled: true,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 6,
                enabled: true,
                spaceBetween: 24,
            },
            1140: {
                slidesPerView: 7,
                enabled: true,
                spaceBetween: 24,
            },
        },
    });

    new window.Swiper('.theme-overview-slider', {
        slidesPerView: 2.6,
        spaceBetween: 16,
        loop: false,
        autoplay: false,
        enabled: true,
        navigation: {
            nextEl: '.slider-button-next-theme-overview',
            prevEl: '.slider-button-prev-theme-overview',
        },
        pagination: false,
        breakpoints: {
            576: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 6,
                spaceBetween: 24,
            },
            1140: {
                slidesPerView: 7,
                spaceBetween: 24,
            },
        },
    });

    // Slider Training list -> with swiper
    const trainingSwiper = new window.Swiper('.slider-training .slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        speed: 300,
        spaceBetween: 30,
        slidesPerView: 2,
        navigation: {
            nextEl: '.slider-button-next',
            prevEl: '.slider-button-prev',
        },
        pagination: {
            el: '.slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 31,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            576: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

    // This is the function that initializes the Swiper library. It's called after the library is loaded.
    const swiperAboReview = new window.Swiper('.v2-wpg-abo-flow .v2-wpg-abo-review-items.swiper', { // i made it specific for the ABO page, so it doesn't interfere with other sliders on the site
        // Optional parameters
        slidesPerView: 1.15,
        slidesPerGroup: 1,
        loop: false,
        autoplay: false,
        spaceBetween: 24,
        pagination: {
            el: '.wpg-abo-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },

        }
    });

    // proposition slider on shop homepage
    function propositionSwiper() {
        new window.Swiper('.post-type-archive-product .swiper-container.propositions', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            autoplay: {
                delay: 5000,
            },
            enabled: true,
            spaceBetween: 30,
            slidesPerView: 1,
            breakpoints: {
                576: {
                    slidesPerView: 3,
                    enabled: false,
                    spaceBetween: 0,
                    loop: false,
                    autoplay: false,
                },
            },
        });
    }

    propositionSwiper();

    // Category/taxonomy page - sorteer functie buttons

    function shopCategoryFilterSlider() {
        const categorySlider = new Swiper('.shop-category-filter-container', {
            // Optional parameters
            direction: 'horizontal',
            slidesPerGroup: 2,
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false,
            slidesPerViewFit: true,
            navigation: {
                nextEl: '.slider-button-next-categories',
                prevEl: '.slider-button-prev-categories',
            },
            breakpoints: {
                768: {
                    slidesPerGroup: 5,
                },
            },
        });
    }
    shopCategoryFilterSlider();


    // Swiper settings for landingpage theme navigation
    const themeNavigationSlider = new Swiper ('.theme-navigation-slider', {
        // Optional parameters
        direction: 'horizontal',
        freeMode: true,
        slidesPerView :'auto',
        loop : false,
        slidesPerViewFit : true,
        spaceBetween: 8,
        breakpoints: {
            768: {
                slidesPerGroup: 3,
            }
        },
    });


    // BC- slider -> max 4 cards
    $(document).on('init-bc-card-slider', function() {
        var productListSlider = new Swiper('.init-bc-card-slider.js-hero-slider-product-list', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            loop: true,
            autoplay: false,
            spaceBetween: 30,
            navigation: {
                nextEl: '.hero-slider-product-list-button-next',
                prevEl: '.hero-slider-product-list-button-prev',
            },
            pagination: {
                el: '.hero-slider-product-list-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
        });
    });

    // BC- product reviewslider -> max 3 cards
    $(document).on('init-bc-card-slider', function() {
        var productListSlider = new Swiper('.bc-slider-position-1 .init-bc-card-slider.js-hero-slider-product-list', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            loop: false,
            autoplay: false,
            spaceBetween: 30,
            navigation: {
                nextEl: '.bc-slider-position-1 .hero-slider-product-list-button-next',
                prevEl: '.bc-slider-position-1 .hero-slider-product-list-button-prev',
            },
            pagination: {
                el: '.bc-slider-position-1 .hero-slider-product-list-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
            },
        });
    });

    // BC- short slider -> max 3 cards
    $(document).on('init-bc-card-short-slider', function() {
        var productListSlider = new Swiper('.init-bc-card-short-slider.js-hero-slider-product-list', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            loop: true,
            autoplay: false,
            spaceBetween: 30,
            navigation: {
                nextEl: '.hero-slider-product-list-button-next',
                prevEl: '.hero-slider-product-list-button-prev',
            },
            pagination: {
                el: '.hero-slider-product-list-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });
    });

    // Gallery slider
    function GallerySlider() {
        new window.Swiper('.gallery-swiper-container', {
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 1.6,
            breakpoints: {
                992: {
                slidesPerView: 4,
                spaceBetween: 30,
                },
                768: {
                slidesPerView: 2,
                spaceBetween: 30,
                },
            },
    
            navigation: {
                nextEl: '.wpg-slider-next',
                prevEl: '.wpg-slider-prev',
            },
    
            pagination: {
                el: '.wpg-slider-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }

    GallerySlider();

})(jQuery);

